<template>
	<div class="footer-box u-flex u-col-center u-row-center" :class="xieyi ?'footer-box1':''">
		<!-- <img src="../assets/imgs/footer-bg.png" class="footer-img" alt=""> -->
		<div class="footer-conter u-flex-col">
			<div class="contet-top u-flex u-col-top u-row-between">
				<div class="language u-flex-col">
					<img src="../assets/imgs/nav6.png" alt="">
					<div class=" u-flex-col" @mouseleave="show = false">
						<div class="title">Language</div>
						<div class="line" style="width: 48px"></div>
						<div class="change-lang u-flex u-col-center u-row-center" @mouseover="show = true">
							<span v-if="$locale == 'en'">English</span>
							<span v-if="$locale == 'zh'">简体中文</span>
							<i class="el-icon-arrow-down"></i>
						</div>
						<div class="change-lang" style="padding: 0;" :class="show ? '' : 'lang-show'">
							<span v-if="$locale == 'en'" @click="changeyuyan('zh')">简体中文</span>
							<span v-if="$locale == 'zh'" @click="changeyuyan('en')">English</span>
						</div>
					</div>
				</div>
				<div class="language-h5 u-flex u-col-center u-row-between">
					<img src="../assets/imgs/nav6.png" alt="">
					<div class="language-right u-flex u-col-center">
						<img src="../assets/imgs/nav3.png" alt="" @click="show = !show">
						<span v-if="$locale == 'en'" @click="show = !show">English</span>
						<span v-if="$locale == 'zh'" @click="show = !show">简体中文</span>
						<div class="change-lang" style="padding: 0;" :class="show ? '' : 'lang-show'">
							<span v-if="$locale == 'en'" @click="changeyuyan('zh')">简体中文</span>
							<span v-if="$locale == 'zh'" @click="changeyuyan('en')">English</span>
						</div>
					</div>
				</div>
				<div class="footer-list u-flex u-col-top">
					<div class="item u-flex-col">
						<div class="title">{{ $t('腕表展廊') }}</div>
						<div class="line"></div>
						<div class="u-flex-col">
							<span class="text" v-for="(item,index) in list" :key="index" @click="toinfo(item)">{{ $locale == 'en' ? item.nameEnglish : item.name }}</span>
						</div>
					</div>
					<div class="item u-flex-col">
						<div class="title">{{ $t('使用与服务') }}</div>
						<div class="line"></div>
						<div class="u-flex-col">
							<span class="text" @click="topath('/check')">{{ $t('真伪查询服务') }}</span>
							<span class="text" @click="topath('/asked')">{{ $t('常见问题') }}</span>
							<span class="text" @click="topath('contact_us')">{{ $t('联系我们') }}</span>
						</div>
					</div>
					<div class="item u-flex-col">
						<div class="title">{{ $t('品牌探索') }}</div>
						<div class="line"></div>
						<div class="u-flex-col">
							<span class="text" @click="topath('/about')">{{ $t('关于品牌') }}</span>
							<span class="text" @click="topath('/news')">{{ $t('新闻模块') }}</span>
						</div>
					</div>
					<div class="item u-flex-col">
						<div class="title">{{ $t('服务政策') }}</div>
						<div class="line"></div>
						<div class="u-flex-col">
							<span class="text" @click="topath('/xieyi?type=1')">{{ $t('服务条款') }}</span>
							<span class="text" @click="topath('/xieyi?type=2')">{{ $t('隐私政策') }}</span>
						</div>
					</div>
				</div>
				<!-- <div class="top-left u-flex u-col-bottom u-row-center" style="padding-right: 10%;">
					<div class="left-item">
						<span class="span3" @click="totext(1)">{{$t('关于品牌')}}</span>
						<span class="span3" @click="totext(2)">{{$t('防伪检测')}}</span>
						<span class="span3" @click="totext(3)">{{$t('品牌新闻')}}</span>
						<span class="span3" @click="totext(4)">{{$t('联系我们')}}</span>
					</div>
				</div> -->
				<!-- <div class="top-right u-flex u-row-center" style="border: none;white-space: nowrap;">
					
					<img src="../assets/imgs/1.svg" alt="">
					<img src="../assets/imgs/2.svg" alt="">
					<img src="../assets/imgs/3.svg" alt="">
					<img src="../assets/imgs/4.svg" alt="">
					<img src="../assets/imgs/5.svg" alt="">
					<img src="../assets/imgs/6.svg" alt="">
					<img src="../assets/imgs/7.svg" alt="">
				</div> -->
				<!-- <div class="top-h5 u-flex u-col-center u-row-center">
					<img src="../assets/imgs/down-logo.png" style="width: 80px;height: 40px;margin-right: 30px;margin-bottom: 10px;" alt="">
					<div class="u-flex-col u-col-top h5-span3">
						<span class="span3" @click="totext(2)">{{$t('防伪检测')}}</span>
						<span class="span3" @click="totext(4)">{{$t('联系我们')}}</span>
					</div>
				</div> -->
			</div>
			<div class="contet-down u-flex u-col-center u-row-center">
				<div class="u-flex u-col-center down-item" @click="openurl">
					<img src="../assets/imgs/footer-img.png" alt="">
					<span class="span1">Copyright Jinlery. All rights reserved.</span>
				</div>
				<div class="u-flex u-col-center" @click="openurl">
					<img src="../assets/imgs/footer-img.png" alt="">
					<span class="span2">粤ICP备2022146877号-1</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			xieyi: {
				typeof: Boolean,
				default: false
			}
		},
		data() {
			return {
				show: false,
				list: []
			}
		},
		created() {
			this.getlist()
		},
		methods: {
			toinfo(item) {
				if(this.$route.path == '/list') {
					this.$router.push({ path: '/list',query: {id: item.id} }); 
					location.reload()
				} else {
					this.$router.push({
						path: "/list",
						query: {
							id: item.id
						}
					})
				}
				
			},
			changeyuyan(str){
				if(this.$locale == str){
					this.$message.error(this.$t('当前为该语言无需切换'))
					return
				}
				this.$i18n.locale = str
				window.localStorage.locale = str
				this.$router.go()
			},
			getlist() {
				this.$http.post('/api/Index/gety').then((res) => {
					this.list = res.result
				})
			},
			topath(url) {
				if(this.$route.path == '/xieyi' && url.indexOf('type') != -1) {
					this.$router.push(url)
					location.reload()
				} else if(this.$route.path == url) {
					location.reload()	
				} else {
					this.$router.push(url)

				}
			},
			openurl(){
				window.location.href = 'https://beian.miit.gov.cn/#/Integrated/index'
			},
			totext(type) {
				if (type == 1) {
					this.$router.push({
						path: '/about'
					})
				}
				if (type == 2) {
					this.$router.push({
						path: '/check'
					})
				}
				if (type == 3) {
					this.$router.push({
						path: '/news'
					})
				}
				if (type == 4) {
					this.$router.push({
						path: '/contact_us'
					})
				}
			}
		}
	}
</script>

<style lang="scss">
	.footer-box1 {
		display: none;
	}
	.footer-box {
		width: 100vw;
		// height: 304px;
		// overflow: hidden;
		position: relative;
		z-index: 1;
		background: #0B0B0B;
		// background-color: #256C42;

		.footer-conter {
			width: 100%;
			// height: 304px;
			// max-width: 1600px;

			.contet-top {
				
				.line {
					width: 28px;
					height: 2px;
					background: #FFFFFF;
					margin: 18px 0;
				}
				.language {
					img {
						width: 76px;
						height: 54px;
						margin-top: 5px;
					}
					.title {
						font-size: 18px;
						font-family: Poppins, Poppins;
						font-weight: 600;
						color: #FFFFFF;
						padding: 38px 0 0;
					}
					.lang-show {
						opacity: 0;
					}
					.change-lang {
						padding: 0 0 0;
						span {
							padding: 0 9px 0 0;
							font-size: 16px;
							font-family: Gilroy, Gilroy;
							font-weight: 500;
							color: #FFFFFF;
						}
						i {
							font-size: 15px;
							color: #fff;
						}

					}
					
				}
				.footer-list {
					.item {
						width: 250px;
						.title {
							font-size: 18px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							color: #FFFFFF;
						}
						.text {
							font-size: 16px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: rgba($color: #fff, $alpha: 0.8);
							padding: 0 0 9px;
						}
					}
				}
				.top-left {
					flex: 1;
					margin-right: 20px;

					.left-item {
						.span1 {
							font-size: 14px;
							font-family: SourceHanSansSC-Normal, SourceHanSansSC;
							font-weight: 400;
							color: #FFFFFF;
							margin-bottom: 10px;
						}

						.span2 {
							width: 40px;
							height: 2px;
							background-color: #fff;
							margin-bottom: 10px;
						}

						.span3 {
							font-size: 12px;
							font-family: SourceHanSansSC-Normal, SourceHanSansSC;
							font-weight: 400;
							color: #D7D7D7;
							margin-bottom: 8px;
						}
					}
				}

				.top-right {
					flex: 1;
					border-left: 1px solid rgba(221, 221, 221, 0.2);
					// padding-left: 3%;

					// .span1 {
					// 	font-size: 16px;
					// 	font-family: SourceHanSansSC-Regular, SourceHanSansSC;
					// 	font-weight: 400;
					// 	color: #FFFFFF;
					// 	margin-bottom: 8px;
					// }

					// .span2 {
					// 	font-size: 20px;
					// 	font-family: SourceHanSansSC-Bold, SourceHanSansSC;
					// 	font-weight: bold;
					// 	color: #FFFFFF;
					// 	margin-bottom: 18px;
					// }
					img{
						height: 100px;
						margin-right: 10px;
					}
				}
			}

			.contet-down {
				height: 50px;

				span {
					font-size: 12px;
					font-family: SourceHanSansSC-Normal, SourceHanSansSC;
					font-weight: 400;
					color: #FFFFFF;
				}

				img {
					width: 14px;
					height: 16px;
					margin-right: 10px;
				}
			}
		}

		.footer-img {
			width: 1920px;
			height: 304px;
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translate(-50%, 0%);
			z-index: -1;
		}
	}
	@media screen and (max-width:900px) {
		.footer-box{
			.top-left{
				display: none;
			}
		}
	}
</style>
